import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-jcyoi-landing',
  styleUrls: [],
  template: `
    <div class="prelogin-jcyoi-imgcontainer">
    </div>`
})
export class JcyoiLandingComponent implements OnInit {

  constructor(private titleService: Title) { }

  ngOnInit() {
    this.titleService.setTitle(environment.jcyoiPageTitle);
  }

}
